import React, { Component } from "react";

export class Gallery extends Component {
  render() {
    return (
      <div id="portfolio" className="text-center">
        <div className="container">
          <div className="eventsTitle">
            <h2>Impressionen</h2>
          </div>
          <div className="row">
            <div className="portfolio-items">
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/_W7A9256.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                
                      <img
                        src="img/plants/_W7A9256.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/_W7A9262.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/_W7A9262.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/dan-gold-4LiUI-Y2mI8-unsplash.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/dan-gold-4LiUI-Y2mI8-unsplash.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/markus-spiske-4PG6wLlVag4-unsplash.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/markus-spiske-4PG6wLlVag4-unsplash.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/_W7A9272.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/_W7A9272.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/beetroot-687251_1920.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/beetroot-687251_1920.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/markus-spiske-bk11wZwb9F4-unsplash.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/markus-spiske-bk11wZwb9F4-unsplash.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="iimg/plants/plant-690051_1920.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/plant-690051_1920.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
              <div className="col-sm-6 col-md-4 col-lg-4">
                <div className="portfolio-item">
                  <div className="hover-bg">
                    {" "}
                    <a
                      href="img/plants/_W7A9265.jpg"
                      title="Project Title"
                      data-lightbox-gallery="gallery1"
                    >
                      <img
                        src="img/plants/_W7A9265.jpg"
                        className="img-responsive"
                        alt="Project Title"
                      />{" "}
                    </a>{" "}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Gallery;
